import Vue from "vue";
import moment from "moment";
import { mask } from "vue-the-mask";
import EventConstants, { RoleConstants } from "../../Controls/EventConstants";
import { Component, Watch } from "vue-property-decorator";
import { SalarieIdentiteDto } from "../../../dto/GenApi.iNotPaie.Dto/SalarieIdentiteDto";
import { CommuneDto } from "../../../dto/GenApi.iNotPaie.Dto/CommuneDto";
import { ParametreDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { UtilisateurLightDto } from "../../../dto/GenApi.iNotPaie.Dto/UtilisateurLightDto";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import securiteSocialHelper from "../../../Helper/securiteSocialHelper";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const image_mr = require("../../../assets/img_avatar_MR.png");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const image_mme = require("../../../assets/img_avatar_MME.png");

interface salarieChargeInfos {
    srcImage?: string;
    isModified: boolean;
    dateNaissance: string;
    // eslint-disable-next-line no-use-before-define
    salarieCourant?: salarieModel;
}

interface salarieModel {
    salarie: SalarieIdentiteDto,
    Photo: string
}

@Component({
    components: {
        Input: require("../../../atomicComponents/Input/Input.vue.html")
    },
    directives: { mask }
})
export default class IdentiteSalarieComponent extends Vue {
    public canModify = false;
    public currentId = -1;
    public dataReady = false;
    public isModified = false;
    public isModDemarrage = false;
    public srcImage?: string = "";
    public salarieCourant?: salarieModel = undefined;
    public salarieCharges: salarieChargeInfos[] = [];
    public listIdCharges: number[] = [];
    public listeCivilite: ParametreDto[] = [];
    public listeNationalite: ParametreDto[] = [];
    public listeCommune: CommuneDto[] = [];
    public dateNaissance = "";
    public communeNaissanceCherche = "";
    public communePersonneAPrevenirCherche = "";
    public isInitialized = false;

    public codePostal = "";
    public commune = "";
    public maxBirthDate: string = new Date().toLocaleDateString();

    public numeroSecuriteSociale = "";
    public numeroTelFixe = "";
    public numeroTelMobile = "";
    public personneAPrevenirTelFixe = "";
    public personneAPrevenirTelMobile = "";
    public ifModeCongeActive = true;

    public utilisateurs: UtilisateurLightDto[] = [];

    // eslint-disable-next-line @typescript-eslint/ban-types
    public customTokens: object = {
        ".": { pattern: /./ },
        "#": { pattern: /\d/ },
        X: { pattern: /[0-9a-zA-Z]/ },
        Y: { pattern: /[a-zA-Z\- ]/ },
        S: { pattern: /[a-zA-Z]/ },
        A: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
        a: { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
        "!": { escape: true }
    }

    @Watch("communeNaissanceCherche")
    public onCommuneNaissanceCherchePropertyChanged(): void {
        if (this.communeNaissanceCherche?.length >= 2) {
            this.listeCommune = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(this.communeNaissanceCherche.toLowerCase()) >= 0);
        } else {
            this.listeCommune = [];
        }
    }

    @Watch("codePostal")
    public onCodePostalCherchePropertyChanged(): void {
        this.listeCommune = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(this.codePostal.toLowerCase()) >= 0 && c.CodePostal !== null);
    }

    @Watch("commune")
    public onCommuneCherchePropertyChanged(): void {
        this.listeCommune = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(this.commune.toLowerCase()) >= 0 && c.CodePostal !== null);
    }

    public updateSecuritySocialNumber(): void {
        if (this.salarieCourant?.salarie?.CodeCivilite != null) {
            this.salarieCourant.salarie.Civilite = this.salarieCourant.salarie.CodeCivilite;
        }
        this.numeroSecuriteSociale = securiteSocialHelper.setSecuSocialMandatory(
            this.numeroSecuriteSociale,
            this.salarieCourant?.salarie?.CodeCivilite,
            this.dateNaissance,
            this.getCommuneNaissance(),
            this.getPaysNaissance()
        );

        this.numeroSecuriteSociale = securiteSocialHelper.formatNumeroSecuriteSocial(this.numeroSecuriteSociale.replace(/ /gi, ""));
    }

    public isNumber(value: string | number): boolean {
        return ((value != null) && !isNaN(Number(value.toString())));
    }

    public modifyCommuneNaissance(): void {
        const communeNaissance = this.getCommuneNaissance();
        if (communeNaissance != null && this.salarieCourant != undefined && (this.salarieCourant.salarie.CodePaysNaissance == undefined || this.salarieCourant.salarie.CodePaysNaissance == "")) {
            this.salarieCourant.salarie.CodePaysNaissance = "FR";
        }

        this.modify();
    }

    // modification commune
    public modifyCommune(isCodePostal: boolean): void {
        if (this.salarieCourant == undefined || this.salarieCourant.salarie == undefined) {
            return;
        }

        if (this.salarieCourant.salarie.Frontalier) {
            this.setCommuneFrontalier();

            return;
        }

        let codePostal;
        let libelleCommune;

        if (isCodePostal) {
            codePostal = this.getCodePostal(this.codePostal);
            libelleCommune = this.getLibelleCommune(this.codePostal);
        } else {
            codePostal = this.getCodePostal(this.commune);
            libelleCommune = this.getLibelleCommune(this.commune);
        }

        this.checkCodePostalNonFrontalier(codePostal, libelleCommune);
    }

    private getCodePostal(commune: string) {
        return commune.split(/- (.+)?/, 2)[0].trim();
    }

    private getLibelleCommune(commune: string) {
        return commune.split(/- (.+)?/, 2)[1].trim();
    }

    private checkCodePostalNonFrontalier(codePostal: string, libelleCommune: string): void {
        this.setCommune(this.listeCommune.filter(c => c.CodePostal === codePostal && c.Libelle === libelleCommune)[0]);
    }

    private setCommuneFrontalier(): void {
        this.salarieCourant!.salarie.CommuneCodePostal = this.codePostal;
        this.salarieCourant!.salarie.CommuneLibelle = this.commune;
        this.modify();
    }

    private setCommune(commune: CommuneDto): void {
        if (commune != undefined) {
            this.salarieCourant!.salarie.CommuneCodePostal = commune.CodePostal;
            this.salarieCourant!.salarie.CommuneLibelle = commune.Libelle;
            this.salarieCourant!.salarie.CodeAdressePays = "FR";

            this.modify();
        }

        this.codePostal = this.salarieCourant!.salarie.CommuneCodePostal ?? "";
        this.commune = this.salarieCourant!.salarie.CommuneLibelle ?? "";
    }

    public reloadData(id: number): void {
        if (id <= 0) {
            this.resetData(0);
        } else {
            if (this.currentId >= 0) {
                this.salarieCharges[this.currentId] = {
                    dateNaissance: this.dateNaissance,
                    salarieCourant: this.salarieCourant,
                    srcImage: this.srcImage,
                    isModified: this.isModified
                };
            }
        }

        this.currentId = id;
        this.fetchData();
    }

    public init(): void {
        this.isInitialized = false;

        if (this.isInitialized || ParametresInstance.utilisateurCourant == undefined || ParametresInstance.societeCourante == undefined) {
            return;
        }

        this.canModify = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]);
        this.ifModeCongeActive = ParametresInstance.societeCourante.IsModeCongeActive;

        this.initConstantes();
    }

    public mounted(): void {
        this.isInitialized = false;

        this.maxBirthDate = moment.utc().format("YYYY-MM-DD");

        // On ne sait pas dans quel ordre ça peut arriver (1er appel ou refresh de la page...)
        EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
            this.init();
        });
        EventBus.$on("closeTab", e => {
            if (e.route == this.$route.path) {
                this.isModified = false;
            }
        });
        EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
            this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
        });
        this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);

        this.init();
    }

    public resetData(id: number): void {
        if (this.salarieCharges[id] != undefined) {
            this.salarieCharges[id].isModified = false;
        }
        if (this.currentId == id) {
            this.fetchData();
        }
    }

    public initConstantes(): void {
        ServicesFactoryInstance.ParametresService.getCivilites(data => {
            this.listeCivilite = data;
        });

        ServicesFactoryInstance.ParametresService.getPays(data => {
            this.listeNationalite = data;
            this.listeNationalite.sort((a, b) => (a.Libelle != undefined && b.Libelle != undefined && a.Libelle > b.Libelle) ? 1 : -1);
        });

        ServicesFactoryInstance.UtilisateursService.getUtilisateurs(data => {
            this.utilisateurs = data;
        });

        this.isInitialized = true;
    }

    public refreshIdentite(): void {
        this.fetchData();
    }

    public fetchData(): void {
        this.dataReady = false;
        if (this.salarieCharges[this.currentId] == null || !this.salarieCharges[this.currentId].isModified) {
            if (this.currentId != 0) {
                if (isNaN(Number(this.$route.query.idContrat))) {
                    ServicesFactoryInstance.SalarieService.getSalarieIdentite(this.currentId, this.setData, () => this.dataReady = true);
                } else {
                    ServicesFactoryInstance.SalarieService.getSalarieIdentiteForContrat(this.currentId, Number(this.$route.query.idContrat), this.setData, () => this.dataReady = true);
                }
            } else {
                if (!this.isModified || this.currentId === 0) {
                    this.salarieCourant = {
                        Photo: "",
                        salarie: { Id: 0, BulletinParMail: true, Frontalier: false, Numero: 0 }
                    };
                    this.numeroSecuriteSociale = "";
                    this.numeroTelFixe = "";
                    this.numeroTelMobile = "";
                    this.personneAPrevenirTelFixe = "";
                    this.personneAPrevenirTelMobile = "";
                    this.isModified = true;
                    this.srcImage = image_mr;
                    this.$emit("isModified", true);
                    this.codePostal = "";
                    this.commune = "";
                    this.communeNaissanceCherche = "";
                    this.communePersonneAPrevenirCherche = "";
                    this.dateNaissance = "";
                }
                this.dataReady = true;
            }
        } else {
            this.salarieCourant = this.salarieCharges[this.currentId].salarieCourant;
            this.dateNaissance = this.salarieCharges[this.currentId].dateNaissance;
            this.srcImage = this.salarieCharges[this.currentId].srcImage;
            this.isModified = this.salarieCharges[this.currentId].isModified;
            if (this.salarieCourant != undefined) {
                this.communeNaissanceCherche = this.salarieCourant.salarie.CommuneNaissance == undefined ? "" : this.salarieCourant.salarie.CommuneNaissance;

                this.communePersonneAPrevenirCherche = this.salarieCourant.salarie.PersonneAPrevenirVille == undefined ? "" : this.salarieCourant.salarie.PersonneAPrevenirVille;
                this.codePostal = this.salarieCourant.salarie.CommuneCodePostal == undefined ? "" : this.salarieCourant.salarie.CommuneCodePostal;
                this.commune = this.salarieCourant.salarie.CommuneLibelle == undefined ? "" : this.salarieCourant.salarie.CommuneLibelle;
                if (this.salarieCourant.salarie.NumSecu != undefined) {
                    this.numeroSecuriteSociale = securiteSocialHelper.formatNumeroSecuriteSocial(this.salarieCourant.salarie.NumSecu);
                } else {
                    this.numeroSecuriteSociale = "";
                }

                if (this.salarieCourant.salarie.NumeroTelFixe != undefined) {
                    this.setNumeroTel(this.salarieCourant.salarie.NumeroTelFixe);
                } else {
                    this.numeroTelFixe = "";
                }

                if (this.salarieCourant.salarie.NumeroTelMobile != undefined) {
                    this.setNumeroPort(this.salarieCourant.salarie.NumeroTelMobile);
                } else {
                    this.numeroTelMobile = "";
                }

                if (this.salarieCourant.salarie.PersonneAPrevenirTel != undefined) {
                    this.setPersonneAPrevenirNumeroTel(this.salarieCourant.salarie.PersonneAPrevenirTel);
                } else {
                    this.personneAPrevenirTelFixe = "";
                }

                if (this.salarieCourant.salarie.PersonneAPrevenirTelPort != undefined) {
                    this.setPersonneAPrevenirTelMobile(this.salarieCourant.salarie.PersonneAPrevenirTelPort);
                } else {
                    this.personneAPrevenirTelMobile = "";
                }
            }
            this.dataReady = true;
        }
    }

    public modifiyNumeroTel(): void {
        this.setNumeroTel(this.numeroTelFixe.replace(/ /gi, ""));
        this.modify();
    }

    public setNumeroTel(val: string): void {
        this.numeroTelFixe = "";
        for (let i = 0; i < val.length; i++) {
            this.numeroTelFixe += val[i];
            if (i % 2 == 1 && i > 0) {
                this.numeroTelFixe += " ";
            }
        }

        if (this.numeroTelFixe.length > 20) {
            this.numeroTelFixe = this.numeroTelFixe.substr(0, 20);
        }
    }

    public modifiyPersonneAPrevenirNumeroTel(): void {
        this.setPersonneAPrevenirNumeroTel(this.personneAPrevenirTelFixe.replace(/ /gi, ""));
        this.modify();
    }

    public setPersonneAPrevenirNumeroTel(val: string): void {
        this.personneAPrevenirTelFixe = "";
        for (let i = 0; i < val.length; i++) {
            this.personneAPrevenirTelFixe += val[i];
            if (i % 2 == 1 && i > 0) {
                this.personneAPrevenirTelFixe += " ";
            }
        }

        if (this.personneAPrevenirTelFixe.length > 20) {
            this.personneAPrevenirTelFixe = this.personneAPrevenirTelFixe.substr(0, 20);
        }
    }

    public modifiyPersonneAPrevenirTelMobile(): void {
        this.setPersonneAPrevenirTelMobile(this.personneAPrevenirTelMobile.replace(/ /gi, ""));
        this.modify();
    }

    public setPersonneAPrevenirTelMobile(val: string): void {
        this.personneAPrevenirTelMobile = "";
        for (let i = 0; i < val.length; i++) {
            this.personneAPrevenirTelMobile += val[i];
            if (i % 2 == 1 && i > 0) {
                this.personneAPrevenirTelMobile += " ";
            }
        }

        if (this.personneAPrevenirTelMobile.length > 20) {
            this.personneAPrevenirTelMobile = this.personneAPrevenirTelMobile.substr(0, 20);
        }
    }

    public modifiyNumeroPort(): void {
        this.setNumeroPort(this.numeroTelMobile.replace(/ /gi, ""));
        this.modify();
    }

    public setNumeroPort(val: string): void {
        this.numeroTelMobile = "";
        for (let i = 0; i < val.length; i++) {
            this.numeroTelMobile += val[i];
            if (i % 2 == 1 && i > 0) {
                this.numeroTelMobile += " ";
            }
        }

        if (this.numeroTelMobile.length > 20) {
            this.numeroTelMobile = this.numeroTelMobile.substr(0, 20);
        }
    }

    public modifiyNumeroSecuriteSocial(): void {
        this.numeroSecuriteSociale = securiteSocialHelper.formatNumeroSecuriteSocial(this.numeroSecuriteSociale.replace(/ /gi, ""));
        this.modify();
    }

    public setData(data: SalarieIdentiteDto): void {
        if (data.Id != this.currentId) {
            return;
        }

        this.salarieCourant = { salarie: data, Photo: data.Photo != undefined ? data.Photo : "" };

        if (this.salarieCourant == undefined) {
            return;
        }

        if (this.salarieCourant.salarie.NumSecu != undefined) {
            this.numeroSecuriteSociale = securiteSocialHelper.formatNumeroSecuriteSocial(this.salarieCourant.salarie.NumSecu);
        } else {
            this.numeroSecuriteSociale = "";
        }

        if (this.salarieCourant.salarie.NumeroTelFixe != undefined) {
            this.setNumeroTel(this.salarieCourant.salarie.NumeroTelFixe);
        } else {
            this.numeroTelFixe = "";
        }

        if (this.salarieCourant.salarie.PersonneAPrevenirTel != undefined) {
            this.setPersonneAPrevenirNumeroTel(this.salarieCourant.salarie.PersonneAPrevenirTel);
        } else {
            this.personneAPrevenirTelFixe = "";
        }

        if (this.salarieCourant.salarie.PersonneAPrevenirTelPort != undefined) {
            this.setPersonneAPrevenirTelMobile(this.salarieCourant.salarie.PersonneAPrevenirTelPort);
        } else {
            this.personneAPrevenirTelMobile = "";
        }

        if (this.salarieCourant.salarie.NumeroTelMobile != undefined) {
            this.setNumeroPort(this.salarieCourant.salarie.NumeroTelMobile);
        } else {
            this.numeroTelMobile = "";
        }

        if (this.salarieCourant.Photo != "") {
            this.srcImage = this.salarieCourant.Photo;
        } else if (this.salarieCourant.salarie.Civilite == "M.") {
            this.srcImage = image_mr;
        } else {
            this.srcImage = image_mme;
        }
        this.dateNaissance = moment.utc(this.salarieCourant.salarie.DateNaissance).format("YYYY-MM-DD");

        this.communeNaissanceCherche = this.salarieCourant.salarie.CommuneNaissance == undefined ? "" : this.salarieCourant.salarie.CommuneNaissance;

        this.communePersonneAPrevenirCherche = this.salarieCourant.salarie.PersonneAPrevenirVille == undefined ? "" : this.salarieCourant.salarie.PersonneAPrevenirVille;
        if (this.salarieCourant.salarie != undefined) {
            this.codePostal = this.salarieCourant.salarie.CommuneCodePostal == undefined ? "" : this.salarieCourant.salarie.CommuneCodePostal;
            this.commune = this.salarieCourant.salarie.CommuneLibelle == undefined ? "" : this.salarieCourant.salarie.CommuneLibelle;
        }
        this.dataReady = true;
    }

    public enregistrer(): boolean {
        if (this.salarieCourant == undefined) {
            return false;
        }
        this.salarieCourant.salarie.NumSecu = this.numeroSecuriteSociale.replace(/ /gi, "");
        this.salarieCourant.salarie.NumeroTelFixe = this.numeroTelFixe.replace(/ /gi, "");
        this.salarieCourant.salarie.NumeroTelMobile = this.numeroTelMobile.replace(/ /gi, "");
        this.salarieCourant.salarie.PersonneAPrevenirTelPort = this.personneAPrevenirTelMobile.replace(/ /gi, "");
        this.salarieCourant.salarie.PersonneAPrevenirTel = this.personneAPrevenirTelFixe.replace(/ /gi, "");

        // controlles sur le N° de sécu
        const listError = securiteSocialHelper.isValidSecuSocial(this.numeroSecuriteSociale);

        if (listError.length > 0) {
            NotificationServiceInstance.SendFailedList(listError);

            return false;
        } else {
            // Validation normale
            this.valideEnregistrer();
        }

        return false;
    }

    private valideEnregistrer(): boolean {
        if (this.salarieCourant == undefined) {
            return false;
        }

        this.salarieCourant.salarie.NumSecu = this.salarieCourant.salarie.NumSecu?.toUpperCase().replace(/ /gi, "").replace(/\t/gi, "");
        this.salarieCourant.salarie.DateNaissance = moment.utc(this.dateNaissance).toDate();
        if (this.srcImage == image_mr || this.srcImage == image_mme) {
            this.salarieCourant.salarie.Photo = "";
        } else {
            this.salarieCourant.salarie.Photo = this.srcImage;
        }

        const communeNaissance = this.getCommuneNaissance();
        this.salarieCourant.salarie.CommuneNaissance = communeNaissance ? communeNaissance.Libelle : this.communeNaissanceCherche;

        this.salarieCourant.salarie.PersonneAPrevenirVille = this.communePersonneAPrevenirCherche;
        this.dataReady = false;
        if (this.salarieCourant.salarie.Id == 0) {
            ServicesFactoryInstance.SalarieService.createSalarieIdentite(this.salarieCourant.salarie, data => {
                this.$emit("isModified", false);
                this.isModified = false;

                if (this.salarieCharges[this.currentId] != undefined) {
                    this.salarieCharges[this.currentId].isModified = false;
                }

                if (this.salarieCourant == undefined) {
                    return;
                }
                EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
                EventBus.NavigateTo({ path: "/ficheSalarie/" + data.Id, query: { titre: data.Nom + " " + data.Prenom } });
                NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
            }, () => {
                this.dataReady = true;
            });
        } else {
            ServicesFactoryInstance.SalarieService.updateSalarieIdentite(this.salarieCourant.salarie, data => {
                if (this.salarieCourant == undefined) {
                    return;
                }
                this.setData(data);
                this.dataReady = true;
                this.$emit("isModified", false);
                this.isModified = false;
                this.$emit("identiteUpdated", this.salarieCourant.salarie.Id);
                NotificationServiceInstance.SendSuccess("L'enregistrement du salarié s'est correctement déroulé !");
            }, () => {
                this.dataReady = true;
            });
        }

        return false;
    }

    public getCommuneNaissance(): CommuneDto | undefined {
        let communeTrouvee: CommuneDto | undefined;

        let communes = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale == this.communeNaissanceCherche);
        //Si on ne trouve pas par le libelle + code postal, on cherche par le libelle
        if (communes.length === 0) {
            communes = this.listeCommune.filter(commune => commune.Libelle === this.communeNaissanceCherche);
        }

        if (communes.length > 0 && this.salarieCourant) {
            communeTrouvee = communes[0];
        }

        return communeTrouvee;
    }

    public getPaysNaissance(): ParametreDto | null {
        return this.listeNationalite.filter(c => this.salarieCourant != null && c.Code == this.salarieCourant.salarie.CodePaysNaissance)[0];
    }

    public annuler(): void {
        if (this.salarieCharges[this.currentId] != undefined) {
            this.salarieCharges[this.currentId].isModified = false;
        }
        this.fetchData();
        this.isModified = false;
        this.$emit("isModified", false);

        if (this.currentId == 0) {
            EventBus.$emit(EventConstants.CLOSE_TAB, { path: this.$router.currentRoute.path });
        }
    }

    public modifyNom(): void {
        if (this.salarieCourant && (!this.salarieCourant.salarie.NomNaissance || this.salarieCourant.salarie.NomNaissance == "")) {
            this.salarieCourant.salarie.NomNaissance = this.salarieCourant.salarie.Nom;
        }
        this.modify();
    }

    public modify(): void {
        this.isModified = true;
        this.$emit("isModified", true);
        this.$forceUpdate();
    }

    public changeImage(event: any): void {
        const someData = event.target.files[0];
        const reader = new FileReader();
        const _this = this;
        reader.onload = function () {
            const src = reader.result;
            _this.updateSrc(src);
        };

        if (someData) {
            reader.readAsDataURL(someData);
        }
        this.modify();
    }

    public updateSrc(data: any): void {
        this.srcImage = data;
    }

    public deleteImage(): void {
        if (this.salarieCourant != undefined && this.salarieCourant.salarie.Civilite == "M.") {
            this.srcImage = image_mr;
        } else {
            this.srcImage = image_mme;
        }
        this.modify();
    }

    public hasImage(): boolean {
        return this.srcImage != undefined && this.srcImage != "" && this.srcImage != image_mr && this.srcImage != image_mme;
    }
}




// WEBPACK FOOTER //
// ./src/components/ficheSalarie/identite/identiteSalarie.ts